import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const GoogleLoginSimple = () => {
  const [status, setStatus] = useState('检查中...');
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      setStatus('SDK已加载');
      
      // 初始化Google登录
      setTimeout(() => {
        if (window.google && window.google.accounts) {
          try {
            window.google.accounts.id.initialize({
              client_id: '576179050004-jmm41qq1mr26sj2lf81itlbdv8lsvrk3.apps.googleusercontent.com',
              callback: handleCallback,
              ux_mode: 'popup',
              context: 'signin'
            });
            
            // 渲染登录按钮
            window.google.accounts.id.renderButton(
              document.getElementById('google-signin-btn'),
              { 
                theme: 'outline', 
                size: 'large',
                width: 250
              }
            );
            
            setStatus('Google登录已准备就绪');
          } catch (error) {
            setStatus('初始化失败: ' + error.message);
            console.error('Google登录初始化错误:', error);
          }
        }
      }, 1000);
    };
    
    script.onerror = () => {
      setStatus('SDK加载失败');
    };
    
    document.head.appendChild(script);
    
    return () => {
      // 清理
      const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      if (existingScript && existingScript !== script) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  const handleCallback = async (response) => {
    console.log('Google登录响应:', response);
    
    try {
      // 解析JWT token
      const token = response.credential;
      const payload = JSON.parse(atob(token.split('.')[1]));
      
      console.log('用户信息:', payload);
      
      // 显示获取到的用户信息
      setStatus(`获取到用户信息: ${payload.name} (${payload.email})`);
      
      // 调用后端Google登录接口
      await performBackendLogin(payload);
      
    } catch (error) {
      console.error('处理登录响应失败:', error);
      setStatus('登录处理失败: ' + error.message);
    }
  };

  const performBackendLogin = async (googleUserData) => {
    try {
      setStatus('正在向后端发送登录请求...');
      
      // 调用后端Google登录接口
      const loginResponse = await axios.post('/yonghu/googleLogin', null, {
        params: {
          googleId: googleUserData.sub,
          email: googleUserData.email,
          name: googleUserData.name
        }
      });

      console.log('后端登录响应:', loginResponse.data);

      if (loginResponse.data.code === 0) {
        const { userId, token, username } = loginResponse.data;
        const userData = { 
          id: userId, 
          zhanghao: username, 
          role: 'yonghu',
          loginType: 'google'
        };

        // 保存到本地存储
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('userData', JSON.stringify(userData));
        
        // 更新认证状态
        login(userData, token);
        
        setStatus('登录成功！正在跳转...');
        
        // 获取完整用户信息
        try {
          const userResponse = await axios.get(`/yonghu/info/${userId}`);
          if (userResponse.data.code === 0) {
            const fullUserData = {
              ...userData,
              ...userResponse.data.data
            };
            
            localStorage.setItem('user', JSON.stringify(fullUserData));
            localStorage.setItem('userData', JSON.stringify(fullUserData));
            login(fullUserData, token);
          }
        } catch (err) {
          console.error("获取用户详情失败:", err);
        }
        
        // 延迟跳转，让用户看到成功消息
        setTimeout(() => {
          navigate(`/users/${userId}`);
        }, 1500);
        
      } else {
        setStatus('后端登录失败: ' + (loginResponse.data.msg || '未知错误'));
        console.error('后端登录失败:', loginResponse.data);
      }
    } catch (error) {
      console.error('后端登录请求失败:', error);
      setStatus('后端登录请求失败: ' + (error.response?.data?.msg || error.message));
    }
  };

  return (
    <div style={{ 
      border: '2px solid #4285f4', 
      borderRadius: '8px', 
      padding: '20px', 
      margin: '20px 0',
      backgroundColor: '#f8f9fa'
    }}>
      <h3 style={{ color: '#4285f4', margin: '0 0 15px' }}>Google账号登录</h3>
      
      {/* <p style={{ marginBottom: '15px' }}>
        <strong>状态:</strong> <span style={{ color: '#333' }}>{status}</span>
      </p> */}
      
      <div id="google-signin-btn" style={{ margin: '0 0 15px' }}></div>
      
      <div style={{ fontSize: '12px', color: '#666' }}>
        <p><strong>使用说明:</strong></p>
        <ul style={{ marginLeft: '20px' }}>
          <li>点击Google按钮进行完整登录流程</li>
          <li>成功后会自动跳转到用户页面</li>
          {/* <li>查看浏览器控制台获取详细日志</li> */}
        </ul>
      </div>
    </div>
  );
};

export default GoogleLoginSimple; 